export default __webpack_public_path__ + "static/media/enable-micro.08aa3ee8.svg";